import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getDirections,
  getGames,
  getPlatforms,
  getEventTypes,
  getChannels,
  getTechTags,
  getTypeTags,
  getClassTags,
  getExtraFieldsList,
} from '../../store/actions/collections';

const useFieldsLoader = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDirections('grid'));
    dispatch(getEventTypes('grid'));
    dispatch(getGames('grid'));
    dispatch(getPlatforms('grid'));
    dispatch(getChannels('grid'));
    dispatch(getTechTags('grid'));
    dispatch(getTypeTags('grid'));
    dispatch(getClassTags('grid'));
    dispatch(getExtraFieldsList());
  }, [dispatch]);
};

export default useFieldsLoader;
